export default __webpack_public_path__ + "static/media/dashboard_light.5b368ae2.png";